export enum TicketBatchOperation {
  RESPONSIBLE = 'RESPONSIBLE',
  RESOLVING_AREA = 'RESOLVING_AREA',
}
